import { t } from '../i18n/I18n';
import { ActionMenu } from './Dropdown';
import { Icon } from './Icon';
import { useViewZoom } from './viewZoom';

export type ViewCommand = 'zoomIn' | 'zoomOut' | 'fit' | 'zoomReset';

/** The bottom row's «N % ⌄» («States / Zoom», 1055:50394). Only it hears the percentage, so a zoom re-renders nothing else. */
export function ZoomMenu({ onCommand }: { onCommand: (command: ViewCommand) => void }) {
  const percent = useViewZoom();
  return <ActionMenu label={t('#WebShortcutZoom')} tip={t('#WebTipZoom')} tipSide="above" align="end" className="zoom-menu" triggerClassName="zoom-trigger"
    trigger={<><span>{percent === null ? '—' : t('#WebZoomPercent', percent)}</span><Icon name="chevronDown" size={16} /></>} items={[
      { id: 'zoom-in', label: t('#WebZoomIn'), shortcut: 'zoomIn', onSelect: () => onCommand('zoomIn') },
      { id: 'zoom-out', label: t('#WebZoomOut'), shortcut: 'zoomOut', onSelect: () => onCommand('zoomOut') },
      { id: 'zoom-fit', label: t('#WebZoomToFit'), shortcut: 'fit', onSelect: () => onCommand('fit') },
      { id: 'zoom-100', label: t('#WebZoomTo100'), shortcut: 'zoomReset', onSelect: () => onCommand('zoomReset') }]} />;
}
